export default {
  name: 'KTagList',
  props: {},
  render() {
    return (
      <transition-group
        class="km-tag-list"
        name="km-tag-list"
        tag="div"
      >
        {this.$slots.default}
      </transition-group>
    )
  },
}
